export default "https://assets.egbcdn.net/assets/packs/_/images/logos/egb-com-black-fbfcfc7e82e12051a7321faea90331dc.svg";